<template>
  <div>
    <div class="appMain">
      <Header></Header>
      <AppMain></AppMain>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "./Header";
import Footer from "./Footer";
import AppMain from "./AppMain";
export default {
  components: {
    Header, Footer, AppMain
  }
}
</script>

<style>
* {
  padding: 0;
  margin: 0;
}
.appMain {
  min-height: calc(100vh - 242px);
}
a {
  text-decoration: none;
  color: rgb(61, 61, 61);
}
a:active {
  color: #d80059;
}
</style>